'use strict';

var LocationStateSource = require('./location');
var registerStateSource = require('../core/registerStateSource');

module.exports = function (marty) {
  registerStateSource(marty, 'LocationStateSource', 'location', LocationStateSource);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/location-state-source/index.js
 ** module id = 575
 ** module chunks = 0
 **/